module.exports = __webpack_public_path__ + "static/media/Header_Image_001.f52c9cb0.png";